import { cn } from '~/lib/cn';

export interface FieldBlockProps {
  label: string;
  className?: string;
  children: React.ReactNode;
}

const FieldBlock = ({
  label,
  className,
  children,
}: FieldBlockProps): JSX.Element => {
  const _label = label ? `${label}:` : '';

  return (
    <div data-testid="field-block" className={cn('flex', className)}>
      <label className="mr-sm inline-block w-[10em] shrink-0 whitespace-nowrap text-body-xs font-semibold text-subtle">
        {_label}
      </label>
      <div className="inline-block w-full">{children}</div>
    </div>
  );
};

FieldBlock.displayName = 'FieldBlock';

export interface FieldValueProps {
  label: string;
  value: string;
  className?: string;
}

const FieldValue = ({ label, value, className }: FieldValueProps) => (
  <div data-testid="field-value">
    <div className="flex items-center">
      <label className="mr-sm inline-block w-[10em] shrink-0 whitespace-nowrap text-body-xs font-semibold text-subtle">
        {label}:
      </label>
      <span className={cn('inline-block', className)}>{value}</span>
    </div>
  </div>
);

FieldValue.displayName = 'FieldValue';

export { FieldBlock, FieldValue };
